import React from 'react'
import './ShowAppointmentFaild.css'
import { Input, Icon, Button, Form, DatePicker } from 'antd'
// import Cookies from 'js-cookie' // js-cookie
import {setKey,getKey} from '@/utils/Cookie'
import faildImg from '@/img/faild.png'
const FormItem = Form.Item
const { RangePicker } = DatePicker

class ShowAppointmentFaild extends React.Component {
  state = {
    ArrayMessage: null
  }
  componentWillMount() {
    // console.log(JSON.parse(getKey('MessageFiald')))

    this.setState({
      ArrayMessage: JSON.parse(getKey('MessageFiald'))
    })
  }
  Record() {
    // console.log('123')
    this.props.history.push('/Main/Home/PersonAppointment')
  }
  render() {
    const { ArrayMessage } = this.state
    return (
      <div className="ShowAppointmentFaild">
        <div className="ShowAppointmentFaild_conten">
          <div className="img">
            <img src={faildImg}></img>
          </div>
          <div className="text">预约失败</div>
          <div className="messageContent">
            <div className="error">
              失败原因：
              <span>{ArrayMessage.message}</span>
            </div>
            {ArrayMessage.data &&
              ArrayMessage.data.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    <span>{item.name} </span>
                    <span>{item.idCard}</span>
                  </div>
                )
              })}
          </div>
          <div className="buttonConten">
            <div className="buttonConten_right" onClick={el => this.Record()}>
              重新预约
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ShowAppointmentFaild
